import { render } from "./LbrxKeyboardPopup.vue?vue&type=template&id=4d180678&scoped=true"
import script from "./LbrxKeyboardPopup.vue?vue&type=script&lang=js"
export * from "./LbrxKeyboardPopup.vue?vue&type=script&lang=js"

import "./LbrxKeyboardPopup.vue?vue&type=style&index=0&id=4d180678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d180678"]])

export default __exports__